/* WWP Quiz v8 JS -- loaded by wwp-quiz snippet */
(function(){
  var sect=document.getElementById('wwp-quiz-section');
  if(!sect||sect.dataset.wqBound)return;
  sect.dataset.wqBound='1';
  var stage=document.getElementById('wq-stage');
  var bar=document.getElementById('wq-bar');
  var result=document.getElementById('wq-result');
  var intro=document.getElementById('wq-intro');
  var st={pet:null,need:null,profile:null};
  var NEEDS=[
    {id:'walk',label:'Walks & Travel',icon:'wq-travel'},
    {id:'feed',label:'Mealtimes',icon:'wq-feed'},
    {id:'comfort',label:'Comfort & Rest',icon:'wq-comfort'},
    {id:'play',label:'Play & Enrichment',icon:'wq-play'},
    {id:'grooming',label:'Grooming & Care',icon:'wq-groom'},
    {id:'safety',label:'Safety & Health',icon:'wq-safe'}
  ];
  var PROFILES={
    dog:{q:'How big is your dog?',opts:[
      {id:'small',label:'Small',hint:'Under 8kg'},
      {id:'medium',label:'Medium',hint:'8–20kg'},
      {id:'large',label:'Large',hint:'Over 20kg'}
    ]},
    cat:{q:'How old is your cat?',opts:[
      {id:'kitten',label:'Kitten',hint:'Under 1 year'},
      {id:'adult',label:'Adult',hint:'1–9 years'},
      {id:'senior',label:'Senior',hint:'10 years +'}
    ]}
  };
  var TIPS={
    small:'Small dogs: check size guides on each product page — we’ve included sizes for the smallest breeds.',
    medium:'Medium dogs: most products will suit you, but always check weight limits on each page.',
    large:'Large dogs: look for the bigger size options and always check weight limits before ordering.',
    kitten:'Kittens: introduce new toys gradually and always supervise play.',
    adult:'Adult cats: let your cat explore anything new at their own pace.',
    senior:'Senior cats often prefer softer beds and gentler play. Ask your vet if unsure.'
  };
  var COLS={
    'dog-walk':'/collections/going-on-an-adventure?filter.p.tag=Dog+Walk+and+Travel',
    'dog-feed':'/collections/making-mealtimes-easier?filter.p.tag=Dog+Feed+and+Hydrate',
    'dog-comfort':'/collections/a-cosy-spot-for-your-pet?filter.p.tag=Dog+Comfort',
    'dog-play':'/collections/keeping-your-pet-entertained?filter.p.tag=Dog+Play+and+Enrichment',
    'dog-grooming':'/collections/grooming-made-simple?filter.p.tag=Dog+Grooming',
    'dog-safety':'/collections/keeping-your-pet-safe?filter.p.tag=Dog+Safety',
    'cat-walk':'/collections/going-on-an-adventure?filter.p.tag=Cat+Walk+and+Travel',
    'cat-feed':'/collections/making-mealtimes-easier?filter.p.tag=Cat+Feed+and+Hydrate',
    'cat-comfort':'/collections/a-cosy-spot-for-your-pet?filter.p.tag=Cat+Comfort',
    'cat-play':'/collections/keeping-your-pet-entertained?filter.p.tag=Cat+Play+and+Enrichment',
    'cat-grooming':'/collections/grooming-made-simple?filter.p.tag=Cat+Grooming',
    'cat-safety':'/collections/keeping-your-pet-safe?filter.p.tag=Cat+Safety'
  };
  var PICKS={
    dog:{
      walk:[['waterproof-dog-car-seat-cover-with-storage-pocket'],['hands-free-retractable-dog-lead'],['nylon-dog-carrier-backpack','small,medium'],['folding-travel-dog-feeder-bowl'],['large-dog-water-bottle-800ml'],['hands-free-chest-strap-dog-lead']],
      feed:[['stainless-steel-raised-dog-bowl'],['anti-choke-slow-feeder-bowl','medium,large'],['suction-cup-slow-feeder-bowl-for-dogs'],['large-dog-water-bottle-800ml'],['absorbent-pet-feeding-mat'],['folding-travel-dog-feeder-bowl']],
      comfort:[['breathable-cooling-mat-for-dogs'],['self-watering-cooling-mat-for-dogs'],['waterproof-dog-raincoat-with-hood'],['round-plush-pet-bed','small'],['fleece-hoodie-for-small-dogs','small'],['knitted-winter-sweater-for-small-dogs','small']],
      play:[['iq-treat-ball-for-dogs'],['bite-resistant-treat-dispensing-ball-for-dogs'],['durable-rope-chew-toy-for-dogs'],['tough-squeaky-chew-toy-for-large-dogs','medium,large'],['bite-resistant-frisbee-dog-toy'],['usb-rechargeable-bouncing-ball-dog-toy'],['cotton-rope-chew-toy-for-puppies','small']],
      grooming:[['pet-hair-removal-grooming-gloves'],['rechargeable-electric-dog-nail-clippers'],['pet-grooming-hammock'],['round-tip-pet-grooming-scissors-6-inch'],['cordless-pet-grooming-clipper-set'],['tick-remover-tool-for-pets']],
      safety:[['reflective-dog-harness-and-lead-set'],['led-glow-in-the-dark-dog-lead'],['elastic-reflective-dog-car-seat-belt'],['cute-dog-leash-and-collar-set'],['rechargeable-led-dog-collar-pendant']]
    },
    cat:{
      walk:[['transparent-pet-backpack-carrier'],['escape-proof-cat-walking-harness'],['portable-pet-water-bottle-and-feeder'],['glow-in-the-dark-cat-collar']],
      feed:[['ceramic-double-cat-bowl-set'],['automatic-pet-feeder-3-8l'],['absorbent-pet-feeding-mat'],['hoopet-automatic-pet-feeder-and-water-dispenser'],['silicone-pet-food-can-covers'],['combination-automatic-pet-feeder-water-bowl']],
      comfort:[['cosy-house-style-cat-bed'],['hanging-window-cat-hammock'],['round-felt-tunnel-bed-for-cats-and-small-pets'],['all-season-pet-tent-nest'],['fleece-jumper-for-cats'],['round-plush-pet-bed']],
      play:[['plush-teaser-wand-cat-toy-with-bell'],['long-pole-feather-cat-wand-toy'],['natural-catnip-chew-sticks','adult,senior'],['catnip-fur-ball-toys-for-cats'],['automatic-rolling-ball-cat-toy'],['interactive-cat-ball-launcher-toy'],['silvervine-fish-cat-chew-toy']],
      grooming:[['pet-hair-removal-grooming-gloves'],['electric-steam-pet-grooming-brush'],['stainless-steel-nail-clippers-for-cats-and-dogs'],['tear-stain-wet-wipes-for-pets'],['corner-massage-cat-scratcher-brush'],['pet-grooming-hammock']],
      safety:[['escape-proof-cat-walking-harness'],['glow-in-the-dark-cat-collar'],['personalised-glow-in-the-dark-cat-collar-with-id-tag'],['glow-in-the-dark-bell-cat-collar'],['balcony-safety-net-for-cats-and-dogs']]
    }
  };
  function el(tag,cls,html){var e=document.createElement(tag);if(cls)e.className=cls;if(html!==undefined)e.innerHTML=html;return e;}
  function esc(s){return String(s).replace(/[&<>"]/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];});}
  function money(c){return '£'+(c/100).toFixed(2);}
  function setBar(n,of){bar.style.width=Math.round((n/of)*100)+'%';}
  function optBtn(o){
    var b=el('button','wwp-quiz__opt');b.type='button';
    b.innerHTML='<span class="wwp-qi"><svg><use href="#'+o.icon+'"/></svg></span><span>'+esc(o.label)+'</span>'+(o.hint?'<span class="wwp-quiz__hint">'+esc(o.hint)+'</span>':'');
    return b;
  }
  function step1(){
    st={pet:null,need:null,profile:null};
    result.classList.remove('is-active');intro.style.display='';stage.style.display='';
    setBar(1,3);stage.innerHTML='';
    stage.appendChild(el('p','wwp-quiz__counter','Step 1 of 3'));
    stage.appendChild(el('p','wwp-quiz__question','What kind of pet do you have?'));
    var opts=el('div','wwp-quiz__opts wwp-quiz__opts--3');
    [{id:'dog',label:'Dog',icon:'wq-dog'},{id:'cat',label:'Cat',icon:'wq-cat'}].forEach(function(o){
      var b=optBtn(o);
      b.addEventListener('click',function(){b.classList.add('is-picked');st.pet=o.id;setTimeout(step2,140);});
      opts.appendChild(b);
    });
    stage.appendChild(opts);
  }
  function step2(){
    setBar(2,3);stage.innerHTML='';
    stage.appendChild(el('p','wwp-quiz__counter','Step 2 of 3'));
    stage.appendChild(el('p','wwp-quiz__question','What do they need right now?'));
    var opts=el('div','wwp-quiz__opts');
    NEEDS.forEach(function(o){
      var b=optBtn(o);
      b.addEventListener('click',function(){b.classList.add('is-picked');st.need=o;setTimeout(step3,140);});
      opts.appendChild(b);
    });
    stage.appendChild(opts);
    var bk=el('button','wwp-quiz__back','← Back');bk.type='button';bk.addEventListener('click',step1);stage.appendChild(bk);
  }
  function step3(){
    var pr=PROFILES[st.pet];
    setBar(3,3);stage.innerHTML='';
    stage.appendChild(el('p','wwp-quiz__counter','Step 3 of 3'));
    stage.appendChild(el('p','wwp-quiz__question',esc(pr.q)));
    var opts=el('div','wwp-quiz__opts wwp-quiz__opts--3');
    pr.opts.forEach(function(o){
      var b=optBtn(o);
      b.addEventListener('click',function(){b.classList.add('is-picked');st.profile=o.id;setTimeout(showResults,140);});
      opts.appendChild(b);
    });
    stage.appendChild(opts);
    var bk=el('button','wwp-quiz__back','← Back');bk.type='button';bk.addEventListener('click',step2);stage.appendChild(bk);
  }
  function who(){
    if(st.pet==='cat')return st.profile==='kitten'?'your kitten':'your '+st.profile+' cat';
    return 'your '+st.profile+' dog';
  }
  function showResults(){
    stage.style.display='none';intro.style.display='none';
    result.classList.add('is-active');bar.style.width='100%';
    document.getElementById('wq-result-heading').textContent='Our picks for '+who();
    document.getElementById('wq-result-sub').textContent=st.need.label;
    var colKey=st.pet+'-'+st.need.id;
    document.getElementById('wq-cta').href=COLS[colKey]||'/collections/'+st.pet+'-essentials';
    document.getElementById('wq-tip').textContent=TIPS[st.profile]||'';
    var grid=document.getElementById('wq-grid');
    grid.innerHTML='<p class="wwp-quiz__load">Finding your picks…</p>';
    var list=(PICKS[st.pet]||{})[st.need.id]||[];
    var handles=list.filter(function(i){return !i[1]||i[1].split(',').indexOf(st.profile)>-1;}).slice(0,6).map(function(i){return i[0];});
    Promise.all(handles.map(function(h){
      return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    })).then(function(res){
      var items=res.filter(function(p){return p&&p.available;}).slice(0,4);
      grid.innerHTML='';
      if(!items.length){grid.innerHTML='<p class="wwp-quiz__load">We\'re restocking this range — see the full collection below.</p>';return;}
      items.forEach(function(p){
        var a=el('a','wwp-quiz__card');a.href='/products/'+p.handle;
        var img=p.featured_image||(p.images&&p.images[0])||'';
        if(img)img=img+(img.indexOf('?')>-1?'&':'?')+'width=400';
        var low=(p.price_min!==undefined)?p.price_min:p.price;
        var price=(p.price_varies?'From ':'')+money(low);
        a.innerHTML='<span class="wwp-quiz__imgwrap">'+(img?'<img src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy" width="400" height="400">':'')+'</span>'
          +'<span class="wwp-quiz__ct">'+esc(p.title)+'</span>'
          +'<span class="wwp-quiz__cp">'+price+'</span>'
          +'<span class="wwp-quiz__cb">View product</span>';
        grid.appendChild(a);
      });
    });
  }
  document.getElementById('wq-restart').addEventListener('click',function(){stage.style.display='';step1();});
  step1();
})();
